import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const DasboardAPI = createApi({
    reducerPath: "DasboardAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        listDashboardCount: builder.query({
            query: () => `/admin/data-counts`,
        }),

        editAdminProfile: builder.mutation({
            query: (formData) => ({
              url: "admin/profile-update",
              method: "PATCH",
              body: formData,
            }),
          }),
          getAdminProfile: builder.query({
            query: () => `admin/me`,
          }),
        
          downloadOrderData: builder.query({
            query: ({fromDate, toDate}) => `admin/orders/export-items?from=${fromDate}&to=${toDate}`,
        }),

    }),
});

export const { useListDashboardCountQuery,useEditAdminProfileMutation, useGetAdminProfileQuery , useDownloadOrderDataQuery } = DasboardAPI;
